import { VStack, Text, Box } from '@chakra-ui/react'

import { titleStyle, containerStyle, paragraphStyle } from './styles'

interface Props {
  id?: string
  title: string
  paragraph: React.ReactNode
}

function Paragraph({ id, title, paragraph }: Props): React.ReactElement {
  return (
    <VStack id={id} spacing="2" sx={containerStyle}>
      <Text sx={titleStyle}>{title}</Text>
      <Box sx={paragraphStyle}>{paragraph}</Box>
    </VStack>
  )
}

export default Paragraph
